// extracted by mini-css-extract-plugin
module.exports = {"listCoverImage":"src-components-List-CoverImage-styles-style-module__listCoverImage--3bLxs","coverImage":"src-components-List-CoverImage-styles-style-module__coverImage--1GYM3"};